import { parsedPhoneNumberAsString } from "../../../../../../components/global_components/form_components/ControlledPhoneNumber";
import { SubscriberContactMethod } from "../../../../../../queries/notify";
import { buildAppIdentifierString } from "./buildAppIdentifierString";

export function buildIdentifierString(
  subscriberContactMethod?:
    | SubscriberContactMethod
    | {
        type: SubscriberContactMethod["type"];
        identifier: string;
        metadata?: SubscriberContactMethod["metadata"];
      },
) {
  if (!subscriberContactMethod) return "";

  switch (subscriberContactMethod.type) {
    case "Phone":
      return parsedPhoneNumberAsString(subscriberContactMethod.identifier);
    case "App":
      return buildAppIdentifierString(
        subscriberContactMethod.metadata?.platformDetails,
        subscriberContactMethod.metadata?.deviceType,
      );
    default:
      return subscriberContactMethod.identifier;
  }
}
